import { createAction } from '/@/store/utils';

export const setField = createAction('CROP_MONITORING:SET_FIELD');
